webpackJsonp([114276838955818,60335399758886],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/layout-index.json":
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby (+GraphQL) Stay Static Site Sample"}}},"layoutContext":{}}

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"C:/Sites/gatsby/staystatic/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"C:/Sites/gatsby/staystatic/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"C:/Sites/gatsby/staystatic/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"C:/Sites/gatsby/staystatic/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"C:/Sites/gatsby/staystatic/node_modules/babel-preset-stage-0/lib/index.js\",\"C:/Sites/gatsby/staystatic/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./.cache/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__("./src/layouts/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/layout-index.json");
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { id: "footer" },
	    "A ",
	    _react2.default.createElement(
	      "a",
	      { href: "http://staystatic.github.io" },
	      "Stay Static"
	    ),
	    " Sample Site"
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Header.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { id: 'header' },
	    _react2.default.createElement(
	      'table',
	      { style: { width: "100%" } },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" },
	              data.site.siteMetadata.title
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            { style: { textAlign: "right" } },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/about/" },
	              'About'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ "./src/css/style.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__("./src/components/Header.js");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__("./src/components/Footer.js");
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__("./src/css/style.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// add github ribbon
	//   see https://github.com/blog/273-github-ribbons
	
	var GithubRibbon = function GithubRibbon() {
	  return _react2.default.createElement(
	    'a',
	    { href: 'https://github.com/staystatic/staystatic/tree/master/gatsby' },
	    _react2.default.createElement('img', { style: { position: 'absolute', top: 0, right: 0, border: 0 },
	      src: 'https://camo.githubusercontent.com/38ef81f8aca64bb9a64448d0d70f1308ef5341ab/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6461726b626c75655f3132313632312e706e67', alt: 'Fork me on GitHub', 'data-canonical-src': 'https://s3.amazonaws.com/github/ribbons/forkme_right_darkblue_121621.png' })
	  );
	};
	
	// Import styles.
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { data: data }),
	    _react2.default.createElement(
	      'div',
	      null,
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, null),
	    _react2.default.createElement(GithubRibbon, null)
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-c7801619b3d290cd7234.js